export default __webpack_public_path__ + "static/media/BxLeftArrowAlt 1.df8c8d59.svg";